{
  "name": "SymapfAdmin",
  "version": "1.13.9",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:dev": "ng build -c development",
    "watch": "ng build --watch --configuration development",
    "source": "source-map-explorer dist/SymapfAdmin/browser/main-*.js",
    "test": "jest --coverage=false",
    "test:coverage": "jest"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.2.3",
    "@angular/cdk": "^20.2.1",
    "@angular/common": "^20.2.3",
    "@angular/compiler": "^20.2.3",
    "@angular/core": "^20.2.3",
    "@angular/forms": "^20.2.3",
    "@angular/material": "^20.2.1",
    "@angular/platform-browser": "^20.2.3",
    "@angular/platform-browser-dynamic": "^20.2.3",
    "@angular/router": "^20.2.3",
    "@here/maps-api-for-javascript": "^1.68.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "angularx-qrcode": "^20.0.0",
    "chart.js": "^4.5.0",
    "dayjs": "^1.11.13",
    "dayjs-plugin-utc": "^0.1.2",
    "file-saver": "^2.0.5",
    "jszip": "^3.10.1",
    "lottie-web": "^5.13.0",
    "ng2-charts": "^8.0.0",
    "ng2-file-upload": "^8.0.0",
    "ngx-file-drop": "^16.0.0",
    "ngx-lottie": "^20.0.0",
    "ngx-mat-timepicker": "^20.0.1",
    "ngx-webcam": "^0.4.1",
    "qrcode": "^1.5.4",
    "rxjs": "^7.8.2",
    "swiper": "^11.2.10",
    "timezone": "^1.0.23",
    "tslib": "^2.8.1",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-builders/jest": "^20.0.0",
    "@angular/build": "^20.2.1",
    "@angular/cli": "^20.2.1",
    "@angular/compiler-cli": "^20.2.3",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~5.1.0",
    "@types/jest": "^30.0.0",
    "@types/node": "^22.15.32",
    "@types/qrcode": "^1.5.5",
    "autoprefixer": "^10.4.20",
    "jest": "^30.0.0",
    "jest-preset-angular": "^14.6.0",
    "postcss": "^8.4.49",
    "tailwindcss": "^3.4.17",
    "typescript": "5.8.3"
  }
}